var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaiar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 25L18.2234 20.2341L13.5075 15.5124L23 6V25Z",
    fill: "url(#paint0_linear_1819_5025)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01489 25L8.76174 20.25L4.01489 15.5L4.01489 25Z",
    fill: "url(#paint1_linear_1819_5025)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5074 25L18.251 20.25L4.01489 6L4.01489 15.5L13.5074 25Z",
    fill: "#1A45C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1819_5025",
    x1: 18.2537,
    y1: 10.7623,
    x2: 15.2914,
    y2: 13.7192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A45C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1819_5025",
    x1: 6.98089,
    y1: 20.25,
    x2: 5.49998,
    y2: 21.7274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A45C2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiar);
export default __webpack_public_path__ + "static/media/Maiar.6a5856e8dbe5db45f0427cfcbf0b9788.svg";
export { ForwardRef as ReactComponent };